var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.717 3.22072L6.35367 13.5842C6.28399 13.6542 6.20119 13.7097 6.11001 13.7476C6.01883 13.7854 5.92107 13.8049 5.82234 13.8049C5.72361 13.8049 5.62585 13.7854 5.53467 13.7476C5.44349 13.7097 5.36068 13.6542 5.29101 13.5842L1.28336 9.57247C1.21368 9.50251 1.13088 9.447 1.0397 9.40912C0.948519 9.37125 0.850759 9.35175 0.752027 9.35175C0.653295 9.35175 0.555535 9.37125 0.464356 9.40912C0.373177 9.447 0.290374 9.50251 0.220698 9.57247C0.150746 9.64215 0.0952417 9.72496 0.0573688 9.81615C0.0194958 9.90733 0 10.0051 0 10.1038C0 10.2026 0.0194958 10.3004 0.0573688 10.3915C0.0952417 10.4827 0.150746 10.5655 0.220698 10.6352L4.22985 14.644C4.65278 15.0661 5.22591 15.3033 5.82346 15.3033C6.42101 15.3033 6.99415 15.0661 7.41708 14.644L17.7797 4.28272C17.8495 4.21305 17.9049 4.13029 17.9427 4.03917C17.9805 3.94805 18 3.85037 18 3.75172C18 3.65307 17.9805 3.55538 17.9427 3.46427C17.9049 3.37315 17.8495 3.29039 17.7797 3.22072C17.71 3.15076 17.6272 3.09525 17.536 3.05737C17.4448 3.0195 17.3471 3 17.2484 3C17.1496 3 17.0519 3.0195 16.9607 3.05737C16.8695 3.09525 16.7867 3.15076 16.717 3.22072Z",
    fill: "#41BB5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c39d4d58d8584dd07ed547b6862d8020.svg";
export { ForwardRef as ReactComponent };